import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren, useEffect } from 'react';
import React from 'react';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _cio: any;
  }
}

type CioWrapperProps = PropsWithChildren<object>;

const CioWrapper: React.FC<CioWrapperProps> = ({ children }) => {
  const { user } = useAuth0();

  useEffect(() => {
    if (user) {
      window._cio.identify({
        id: user.email,
      });
    }
  }, [user]);

  return <>{children}</>;
};

export default CioWrapper;
